import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "solution-wrap" }
const _hoisted_2 = { class: "solution-content" }
const _hoisted_3 = { class: "solution-tab-wrap" }
const _hoisted_4 = { class: "solution-tab" }
const _hoisted_5 = ["onClick"]

import { ref, reactive, onMounted, watch } from 'vue'
import EntertainmentPlan from '@/components/mobile/EntertainmentPlan.vue';
import IndustryModel from '@/components/mobile/IndustryModel.vue';
import EducationModel from '@/components/mobile/EducationModel.vue';
import MedicalTreatment from '@/components/mobile/MedicalTreatment.vue';
import MilitaryPolice from '@/components/mobile/MilitaryPolice.vue';
import BannerC from '@/components/BannerC.vue';
import router from '@/router';
import store from '@/store';
import { asynchronousRetrieval } from '@/utils'

import type { RouteLocationNormalized, NavigationGuardNext } from 'vue-router'
// 组件名称，用于 keep-alive 的 include 属性匹配
// 必须与 App.vue 中 keepAliveComponents 数组中的名称一致
const __default__ = {
  name: 'MobileSolution',
  // 在离开路由之前保存滚动位置
  beforeRouteLeave(to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) {
    console.log('=== MobileSolution beforeRouteLeave ===');
    console.log('即将离开到:', to.path);
    console.log('当前滚动位置:', { x: window.scrollX, y: window.scrollY });
    
    // 保存滚动位置
    const scrollPosition = {
      x: window.scrollX,
      y: window.scrollY
    };
    console.log('保存滚动位置到 sessionStorage:', scrollPosition);
    window.sessionStorage.setItem('solutionScrollPosition', JSON.stringify(scrollPosition));
    
    next();
  },
  // 组件激活时（从缓存中恢复）
  activated() {
    console.log('=== MobileSolution activated ===');
    console.log('当前页面:', window.location.href);
    
    // 恢复滚动位置
    const scrollPosition = window.sessionStorage.getItem('solutionScrollPosition');
    console.log('从 sessionStorage 读取的滚动位置:', scrollPosition);
    
    if (scrollPosition) {
      const pos = JSON.parse(scrollPosition);
      console.log('准备恢复滚动位置:', pos);
      
      // 使用 requestAnimationFrame 确保在下一帧执行
      requestAnimationFrame(() => {
        console.log('requestAnimationFrame 执行，滚动到:', pos);
        window.scrollTo(pos.x, pos.y);
        console.log('实际滚动后位置:', { x: window.scrollX, y: window.scrollY });
      });
    } else {
      console.log('没有保存的滚动位置，不做恢复');
    }
  }
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const loadUrl: any = ref({})

const solutionList = ['文娱解决方案', '工业解决方案', '教育解决方案', '医疗解决方案', '军警部队解决方案']
const activeSolutionIndex = ref(-1)

const handleClickEvent = (index: number, item: string) => {
  store.state.programmeIndex = index
  router.push(`/solution?type=${index}&pathName=解决方案,${item}`)
}

onMounted(async () => {
  const query: any = router.currentRoute.value.query;
  activeSolutionIndex.value = query?.type || 0

  const jjfa_bg: any = await asynchronousRetrieval('webimg/images/solution/jjfa-bg.png');
  loadUrl.value = { jjfa_bg }
})

watch(store.state, (newState) => {
  if (newState.programmeIndex != activeSolutionIndex.value) {
    activeSolutionIndex.value = newState.programmeIndex
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(BannerC),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(solutionList, (item, index) => {
              return _createElementVNode("div", {
                key: index,
                class: _normalizeClass(activeSolutionIndex.value == index ? 'active' : ''),
                onClick: ($event: any) => (handleClickEvent(index, item))
              }, _toDisplayString(item), 11, _hoisted_5)
            }), 64))
          ])
        ]),
        (activeSolutionIndex.value == 0)
          ? (_openBlock(), _createBlock(EntertainmentPlan, { key: 0 }))
          : _createCommentVNode("", true),
        (activeSolutionIndex.value == 1)
          ? (_openBlock(), _createBlock(IndustryModel, { key: 1 }))
          : _createCommentVNode("", true),
        (activeSolutionIndex.value == 2)
          ? (_openBlock(), _createBlock(EducationModel, { key: 2 }))
          : _createCommentVNode("", true),
        (activeSolutionIndex.value == 3)
          ? (_openBlock(), _createBlock(MedicalTreatment, { key: 3 }))
          : _createCommentVNode("", true),
        (activeSolutionIndex.value == 4)
          ? (_openBlock(), _createBlock(MilitaryPolice, { key: 4 }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})